import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
import { Page } from 'iconoir-react';
import { useAgentBlocksTextContext } from '../../text/agent-blocks-text-context';
import { InfoChip } from '../shared/InfoChip';
/** The page the companion reads along with the question. */
export function ComposerPageChip({ name }) {
    const text = useAgentBlocksTextContext();
    return (_jsx(InfoChip, { title: text.composer.page(name), icon: _jsx(Page, { width: 13, height: 13 }), children: _jsx(Text, { as: "span", truncate: true, children: name }) }));
}
